import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormFieldComponent } from './form-field.component';

@NgModule({
  imports: [CommonModule, TranslateModule],
  declarations: [FormFieldComponent],
  exports: [FormFieldComponent],
})
export class FormFieldComponentModule {}
